module.exports = __webpack_public_path__ + "static/Mobilny-CRM-w-Twojej-firmie-b0dde3a1e035ee4d6bca4e3f9721cc23.jpg";